<section>
  <div class="flex flex-row">
    <!-- Icônes verticales à gauche -->
    <div class="flex flex-col icon-xs-spacing mr-4">
      <mat-icon class="large-icon" [class.disabled]="!backButtonEnabled" (click)="back()" data-testid="mainBack"
      title="{{ 'components.topSection.back' | transloco }}">arrow_circle_left</mat-icon>

      <mat-icon class="large-icon" (click)="openDialogGamePlayList()" data-testid="openGamePlayList"
      title="{{ 'components.topSection.editGamePlays' | transloco }}">edit_note</mat-icon>

      @if (this.game.isGameStarted()) {
        <mat-icon (click)="addEmptyPlayToGamePlay()" class="large-icon"
          data-testid="addEmptyPlayToGamePlay"
        title="{{ 'components.topSection.addEmptyPlay' | transloco }}">add_box</mat-icon>
      }
    </div>
    <!-- Scoreboard centré -->
    <div class="flex-1 flex justify-center items-center">
      <app-score-board></app-score-board>
    </div>
  </div>
</section>

@if (showLastPlaySection) {
  <app-last-play-section></app-last-play-section>
}